var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlarmBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.40002 18C8.40002 19.9692 10.0299 21.5692 11.9732 21.5692C13.9164 21.5692 15.5463 19.9692 15.5463 18.0615C15.5463 18.0615 15.5463 18.0615 15.5463 18",
    stroke: "#202020",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.073 2.40039C8.85911 2.40039 6.22954 5.02996 6.22954 8.24387V12.9917C6.22954 13.2108 6.1565 13.43 6.01041 13.576L3.59998 17.2282H20.4L18.1356 13.6491C17.9895 13.503 17.9165 13.2839 17.9165 13.0647V8.53604C17.9165 5.17604 15.5061 2.40039 12.073 2.40039Z",
    stroke: "#202020",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmBlack);
export default __webpack_public_path__ + "static/media/alarm_black.e725ba3133695705a219bfb9a711e11d.svg";
export { ForwardRef as ReactComponent };